import { z } from 'zod';

import {
  EmailSchema,
  toSnakeCase,
  withoutObjectKeysWhereValueIs,
} from '@vestigas/utils';

export const zodUpdateUserEndpointSchema = z.tuple([
  z.literal('vadmin'),
  z.literal('users'),
  z.uuid(),
]);

export const zodUpdateUserSchema = z
  .object({
    companyId: z.uuid(),
    email: EmailSchema,
    firstName: z.string().trim(),
    isActive: z.boolean(),
    isSynced: z.boolean().optional(),
    isVestigasSupport: z.boolean().prefault(false),
    lastName: z.string().trim(),
    password: z
      .union([z.literal(''), z.string().trim().min(8)])
      .optional()
      // Strip empty passwords

      .transform((value) => value || undefined),
    permittedSignatureTypes: z.array(
      z.string().transform((value) => toSnakeCase(value)),
    ),
    position: z.union([z.literal(''), z.string().trim()]).optional(),
    syncKey: z.string().trim().nullish(),
    userType: z.union([z.literal(''), z.string()]).nullish(),
  })
  .transform((value) =>
    withoutObjectKeysWhereValueIs(value, [null, undefined]),
  );
